import React from 'react';
import ButtonComponents from './button.components';
import { THEMED_FONT_SIZE_TYPES } from '../../../styles/theme/themed-font-size';

interface ButtonContentProps {
  config: ButtonPresetModel;
  text: string;
  handleOnClick: () => void;
}

export interface ButtonPresetModel {
  fontSize: keyof typeof THEMED_FONT_SIZE_TYPES;
  height: number;
  borderRadius: number;
  padding: number;
  margin: number;
}

const { Container, StyledText } = ButtonComponents;

const ButtonContent: React.FunctionComponent<ButtonContentProps> = ({
  config,
  handleOnClick,
  text
}) => {
  return (
    <Container onClick={handleOnClick} {...config}>
      <StyledText tParams={text} fontSize={config.fontSize} />
    </Container>
  );
};

export default ButtonContent;
